module.exports = __webpack_public_path__ + "img/hejing.7185c757.png";